import ReactDOM from "react-dom/client";
import AppWrapper from "./App"; // ✅ must be AppWrapper
import { initGA } from "./analytics/initGA";
import "primereact/resources/themes/lara-dark-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./Styles/global/index.css";
import { PrimeReactProvider } from "primereact/api";
import { initializeDisplayDensity } from "./utils/displayDensity";
import { installSecureFetch } from "./auth/secureFetch";

installSecureFetch();
initializeDisplayDensity();

// 👇 your GA ID
initGA("G-8QLCJX9CS5");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PrimeReactProvider>
    <AppWrapper />
  </PrimeReactProvider>
);
